import React, { useEffect, useState} from 'react';
import EntityDetail from "../../components/EntityDetail";
import Sidebar from "../../components/Sidebar";
import {useNavigate, useParams} from "react-router-dom";
import {api} from "../../api/Api";


const CentreDetail = () => {
  const [centre, setCentre] = useState(null);
  const {id} = useParams();
  const navigate = useNavigate();

  const fetchCentre = async (id) => {
    try {
        const response = await api.post(
            `/costCenterReport/get`,
          {costCenterCode: id},
        );
        setCentre({name: response.data.report.costCenterDetail.name, data: response.data});
    } catch (error) {
      console.error(`Error fetching detailed data:`, error);
      if (error.response?.status === 401) navigate("/");
    }
  };

  useEffect(() => {
    id && fetchCentre(id);
  }, [id]);

  return (
    <Sidebar>
      <EntityDetail
        entity={centre && centre.data ? centre : null}
        entityName="Střediska"
        apiPath="/costCenter"
        navPath="/centres"
        isCompany={false}
      />
    </Sidebar>
  );
};

export default CentreDetail;
